import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { Box } from '@mui/material'

import GRTabNavigation from '../../../components/GRTabNavigation/GRTabNavigation'
import usePage from '../../../hooks/usePage'
import pageService from '../../../services/PageService'
import { FeatureEffectsTab } from '../../features/motivations/components/FeatureEffectsTab/FeatureEffectsTab'
import { MotivationLocalizationsTab } from '../../features/motivations/components/MotivationLocalizationsTab/MotivationLocalizationsTab'
import { MotivationOverridesTab } from '../../features/motivations/components/MotivationOverridesTab/MotivationOverridesTab'

const motivationTabs: { id: string; nameKey: string; content: ReactNode }[] = [
  { id: 'overrides', nameKey: 'internal-service-management:motivations_tab_overrides', content: <MotivationOverridesTab /> },
  { id: 'localizations', nameKey: 'internal-service-management:motivations_tab_localizations', content: <MotivationLocalizationsTab /> },
  { id: 'feature-effects', nameKey: 'internal-service-management:motivations_tab_feature_effects', content: <FeatureEffectsTab /> },
]

export const MotivationsPage: FC = () => {
  usePage(pageService.getInternalPageWithId('internal-motivations'))
  const { t } = useTranslation()
  const { tab } = useParams<{ tab?: string }>()
  const location = useLocation()
  const selectedIndex = motivationTabs.findIndex((candidate) => candidate.id === tab)

  if (selectedIndex < 0) return <Navigate to={`/internal/motivations/${motivationTabs[0].id}`} replace />

  return (
    <Box>
      <GRTabNavigation
        tabs={motivationTabs.map(({ id, nameKey }) => ({ id, name: t(nameKey) }))}
        selectedTab={selectedIndex}
        pagePrefix="/internal/motivations"
        query={location.search}
        sticky={false}
      />
      {motivationTabs[selectedIndex].content}
    </Box>
  )
}
